import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useOverviewStore = create(
  persist(
    set => ({
      viewTotalAvailableBalance: true,
      viewTotalRevenue: true,
      viewTotalExpense: true,
      setViewTotalAvailableBalance: viewTotalAvailableBalance =>
        set({ viewTotalAvailableBalance }),
      setViewTotalRevenue: viewTotalRevenue => set({ viewTotalRevenue }),
      setViewTotalExpense: viewTotalExpense => set({ viewTotalExpense })
    }),
    {
      name: "overview"
    }
  )
);
